import { EPaymentCardType } from "@common/SimplePaymentMethodCardList";
import MC from "@static/img/paymentCards/MC.png";
import JCB from "@static/img/paymentCards/JCB.png";
import Amex from "@static/img/paymentCards/AMEX.png";
import CB from "@static/img/paymentCards/CB.png";
import Visa from "@static/img/paymentCards/VISA.png";
import Diners from "@static/img/paymentCards/DINERS.png";

// eslint-disable-next-line @typescript-eslint/no-explicit-any
export function getCardTypeLogoSrc(paymentMethodType: EPaymentCardType): any {
    let cardTypeLogoSrc;

    switch (paymentMethodType.toUpperCase()) {
        case EPaymentCardType.MC:
            cardTypeLogoSrc = MC;
            break;
        case EPaymentCardType.JCB:
            cardTypeLogoSrc = JCB;
            break;
        case EPaymentCardType.AMEX:
            cardTypeLogoSrc = Amex;
            break;
        case EPaymentCardType.CB:
            cardTypeLogoSrc = CB;
            break;
        case EPaymentCardType.VISA:
            cardTypeLogoSrc = Visa;
            break;
        case EPaymentCardType.DINERS:
            cardTypeLogoSrc = Diners;
            break;
        default:
            cardTypeLogoSrc = { default: "error" };
            break;
    }

    return cardTypeLogoSrc;
}
